import { alpha } from '@mui/material/styles';

const CALENDAR_CONTAINER_BORDER = '#ddd';

export const getCalendarOptionsSx =
  ({ isDayView }) =>
  (theme) => {
    const secondaryMain = theme.palette.secondary.main;
    const secondaryBorder = alpha(secondaryMain, 0.5);
    const secondaryHoverBackground = alpha(secondaryMain, 0.04);

    return {
      position: 'relative',
      height: 'calc(100vh - 280px)',
      background: '#ffffff',
      border: `1px solid ${CALENDAR_CONTAINER_BORDER}`,
      borderRadius: '4px',
      p: '28px',
      boxSizing: 'border-box',

      '& .fc-event': {
        cursor: 'pointer !important',
      },
      '& .fc .fc-event:hover': {
        backgroundColor: 'var(--fc-event-hover-color) !important',
        borderColor: 'var(--fc-event-hover-color) !important',
      },
      '& .fc .fc-timegrid-event-harness, & .fc .fc-timegrid-event': {
        height: '14px !important',
      },
      '& .fc .fc-timegrid-event .fc-event-main': {
        lineHeight: '14px !important',
        paddingTop: '0 !important',
      },
      '& .fc-event, & .fc-event-title': {
        fontSize: '0.7rem !important',
        color: '#ffffff !important',
      },
      '& .fc .fc-timeGridWeek-view .fc-col-header-cell-cushion': {
        p: '8px 12px',
      },
      '& .fc .fc-dayGridMonth-view .fc-col-header-cell-cushion': {
        fontSize: '11px',
        textTransform: 'uppercase',
      },
      '& .fc .fc-week-header-wrap': {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
      },
      '& .fc .fc-week-header-weekday': {
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.04em',
      },
      '& .fc .fc-week-header-date': {
        fontSize: '20px',
        fontWeight: 400,
      },
      '& .fc .fc-listWeek-view .fc-list-event-graphic': {
        display: 'none',
      },
      '& .fc .fc-listWeek-view .fc-list-day': {
        display: 'none',
      },
      '& .fc .fc-listWeek-view .fc-list-event-time': {
        display: 'table-cell',
        color: 'transparent',
        fontSize: 0,
        fontWeight: 500,
        p: '0 10px',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        width: '120px',
      },
      '& .fc .fc-listWeek-view .fc-list-event-time::before': {
        content: 'attr(data-day-label)',
        color: '#1f2937',
        display: 'inline',
        fontSize: '0.75rem',
        fontWeight: 500,
      },
      '& .fc .fc-listWeek-view .fc-list-event-title': {
        p: '0 !important',
      },
      '& .fc .fc-listWeek-view .fc-list-event-title a': {
        display: 'block',
        m: '3px 6px',
        p: '3px 8px',
        borderRadius: '4px',
        background: 'var(--fc-list-event-bg, #6fa8f5)',
        color: '#ffffff !important',
        fontSize: '0.75rem',
        lineHeight: 1.2,
      },
      '& .fc .fc-listWeek-view .fc-list-event-title a:hover': {
        background: 'var(--fc-list-event-hover, #5d93de)',
      },
      '& .fc .fc-listWeek-view .fc-list-event, & .fc .fc-listWeek-view .fc-list-event td': {
        border: 0,
      },
      '& .fc .fc-listWeek-view .fc-list, & .fc .fc-listWeek-view .fc-list-table': {
        border: '0 !important',
      },
      '.fc-missing-appointment-icon': {
        border: '1px solid #ffffff !important',
        borderRadius: '50%',
      },
      '& .fc .fc-listWeek-view, & .fc .fc-listWeek-view *:not(.fc-missing-appointment-icon)': {
        borderColor: 'transparent !important',
        boxShadow: 'none !important',
        outline: '0 !important',
      },
      '& .fc .fc-listWeek-view .fc-view-harness, & .fc .fc-listWeek-view .fc-view-harness-active, & .fc .fc-listWeek-view .fc-scroller-harness, & .fc .fc-listWeek-view .fc-scroller-harness-liquid, & .fc .fc-listWeek-view .fc-scroller, & .fc .fc-listWeek-view .fc-scroller-liquid, & .fc .fc-listWeek-view .fc-scroller-liquid-absolute':
        {
          border: '0 !important',
          outline: '0 !important',
          boxShadow: 'none !important',
        },
      '& .fc .fc-listWeek-view .fc-list-table tr > *': {
        borderLeft: '0 !important',
        borderRight: '0 !important',
      },
      "& .fc .fc-listWeek-view .fc-list-event[data-list-group-start='true'] > td": {
        boxShadow: 'inset 0 1px 0 #e8edf3 !important',
        pt: '8px',
      },
      "& .fc .fc-listWeek-view .fc-list-event[data-list-first-row='true'] > td": {
        boxShadow: 'none !important',
        pt: 0,
      },
      '& .fc .fc-listWeek-view .fc-list-day-cushion': {
        borderLeft: '0 !important',
        borderRight: '0 !important',
      },
      '& .fc .fc-listWeek-view .fc-list-table tr:first-child > *': {
        borderTop: '0 !important',
      },
      '& .fc .fc-dayGridMonth-view .fc-daygrid-day-top': {
        justifyContent: 'center',
        fontSize: '10px',
        fontWeight: 600,
      },
      '& .fc .fc-day-expand-toggle': {
        background: 'transparent',
        border: 'none',
        color: '#707070',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '11px',
        mt: 0,
        p: '3px 6px 3px 3px',
        textAlign: 'left',
        width: '100%',
        boxSizing: 'border-box',
      },
      '& .fc .fc-day-expand-toggle::after': {
        content: '""',
        width: '6px',
        height: '3px',
        mr: 0,
        flex: '0 0 auto',
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='3' viewBox='0 0 6 3'%3E%3Cpath d='M0.75 0.5L3 2.5L5.25 0.5' stroke='%23707070' stroke-linecap='round' fill='none'/%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
        backgroundSize: '6px 3px',
      },
      "& .fc .fc-day-expand-toggle[data-expanded='true']::after": {
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='3' viewBox='0 0 6 3'%3E%3Cpath d='M0.75 2.5L3 0.5L5.25 2.5' stroke='%23707070' stroke-linecap='round' fill='none'/%3E%3C/svg%3E\")",
      },
      '& .fc .fc-day-expand-toggle:hover': {
        color: '#5f5f5f',
      },
      '& .fc .fc-button-group': {
        gap: '6px',
      },
      '& .fc .fc-toolbar': {
        alignItems: 'center',
        flexWrap: 'nowrap',
      },
      '& .fc': {
        '--fc-page-bg-color': '#ffffff',
        '--fc-neutral-bg-color': '#ffffff',
        '--fc-today-bg-color': '#ffffff',
      },
      '& .fc .fc-toolbar-chunk:first-child': {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: 0,
        ml: isDayView ? '56px' : 0,
      },
      '& .fc, & .fc .fc-view-harness, & .fc .fc-scrollgrid, & .fc .fc-scrollgrid-section, & .fc .fc-daygrid-body, & .fc .fc-timegrid-body, & .fc-theme-standard td, & .fc-theme-standard th':
        {
          background: '#ffffff',
        },
      '& .fc .fc-non-business': {
        background: '#ffffff !important',
      },
      '& .fc-theme-standard .fc-scrollgrid': {
        borderTop: '0 !important',
        borderLeft: '0 !important',
        borderRight: '0 !important',
      },
      '& .fc .fc-scrollgrid-section-header > *, & .fc .fc-col-header tr:first-child th': {
        borderTop: '0 !important',
      },
      '& .fc .fc-timeGridWeek-view .fc-timegrid-col[data-date]': {
        position: 'relative',
      },
      '& .fc .fc-timeGridWeek-view .fc-timegrid-col[data-date]::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '1px',
        background: CALENDAR_CONTAINER_BORDER,
        pointerEvents: 'none',
        zIndex: 1,
      },
      '& .fc .fc-scrollgrid-section:last-child > *': {
        borderBottom: '0 !important',
      },
      '& .fc .fc-scroller, & .fc .fc-scroller-liquid-absolute': {
        overflowY: 'auto !important',
      },
      '& .fc .fc-timegrid-slot-minor': {
        borderTopStyle: 'none !important',
      },
      '& .fc .fc-timegrid-slot-label-cushion': {
        fontSize: '10px',
      },
      '& .fc .fc-timegrid-allday .fc-scrollgrid-shrink-cushion, & .fc .fc-timegrid-allday .fc-timegrid-axis-frame, & .fc .fc-timegrid-allday .fc-timegrid-axis-cushion':
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          p: '0 !important',
        },
      '& .fc .fc-all-day-icon-wrap': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      },
      '& .fc .fc-timegrid-allday .fc-day-today, & .fc .fc-timegrid-allday .fc-day-today .fc-daygrid-day-frame': {
        background: '#ffffff !important',
      },
      '& .fc .fc-toolbar-chunk': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .fc .fc-toolbar-chunk:last-child': {
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: '8px',
        whiteSpace: 'nowrap',
      },
      '& .fc .fc-toolbar-title': {
        m: 0,
        color: '#707070',
        fontSize: '15px',
        fontWeight: 400,
        display: 'inline-block',
      },
      '& .fc .fc-dayWeekday-button, & .fc .fc-dayDate-button': {
        background: 'transparent !important',
        border: 'none !important',
        m: '0 !important',
        minWidth: '0 !important',
        pointerEvents: 'none',
        p: '0 !important',
      },
      '& .fc .fc-dayWeekday-button': {
        color: '#1f2937 !important',
        fontSize: '11px !important',
        fontWeight: '600 !important',
        letterSpacing: '0.04em',
        lineHeight: '1 !important',
      },
      '& .fc .fc-dayDate-button': {
        color: '#1f2937 !important',
        fontSize: '20px !important',
        fontWeight: '400 !important',
        lineHeight: '1 !important',
        mt: '6px !important',
      },
      '& .fc .fc-today-button': {
        background: 'transparent !important',
        border: `1px solid ${secondaryBorder} !important`,
        borderRadius: '4px !important',
        color: `${secondaryMain} !important`,
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1.75,
        minWidth: '64px',
        p: '3px 9px',
      },
      '& .fc .fc-today-button:not(:disabled):hover, & .fc .fc-today-button:not(:disabled):focus, & .fc .fc-today-button:not(:disabled):active':
        {
          background: `${secondaryHoverBackground} !important`,
          borderColor: `${secondaryMain} !important`,
          color: `${secondaryMain} !important`,
        },
      '& .fc .fc-prev-button, & .fc .fc-next-button': {
        background: 'transparent !important',
        border: 'none !important',
        color: '#707070 !important',
        borderRadius: '50% !important',
        minWidth: '22px !important',
        height: '22px',
        width: '22px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: '0 !important',
        lineHeight: '1 !important',
      },
      '& .fc .fc-prev-button:hover, & .fc .fc-next-button:hover': {
        background: `${CALENDAR_CONTAINER_BORDER} !important`,
      },
      '& .fc .fc-prev-button .fc-icon, & .fc .fc-next-button .fc-icon': {
        fontSize: '0.95em',
        fontWeight: 300,
      },
      '& .fc .fc-prev-button:focus, & .fc .fc-next-button:focus': {
        background: 'transparent !important',
        border: 'none !important',
        outline: 'none !important',
        boxShadow: 'none !important',
      },
      '& .calendar-loading-overlay': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    };
  };
